export default __webpack_public_path__ + "static/media/logo-heyho-branco.35a4b38a.svg";